import * as i0 from '@angular/core';
import * as i1 from './calendar-range.module';
import * as i2 from './base-calendar.component';
import * as i3 from './calendar-range.component';
import * as i4 from './calendar-range-cells';
import * as i5 from './base-calendar.module';
export const NbCalendarRangeModuleNgFactory:i0.NgModuleFactory<i1.NbCalendarRangeModule> = (null as any);
var _decl0_0:i2.NbBaseCalendarComponent<any,any> = (<any>(null as any));
var _decl0_1:i3.NbCalendarRangeComponent<any> = (<any>(null as any));
var _decl0_2:i4.NbCalendarRangeDayCellComponent<any> = (<any>(null as any));
var _decl0_3:i4.NbCalendarRangeYearCellComponent<any> = (<any>(null as any));
var _decl0_4:i5.NbBaseCalendarModule = (<any>(null as any));
var _decl0_5:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_6:i0.ElementRef<any> = (<any>(null as any));
function _View_NbCalendarRangeComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_NbCalendarRangeComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_1.boundingMonth;
  currVal_0;
  const currVal_1:any = _decl0_1.startView;
  currVal_1;
  const currVal_2:any = _decl0_1.min;
  currVal_2;
  const currVal_3:any = _decl0_1.max;
  currVal_3;
  const currVal_4:any = _decl0_1.filter;
  currVal_4;
  const currVal_5:any = _decl0_1.dayCellComponent;
  currVal_5;
  const currVal_6:any = _decl0_1.monthCellComponent;
  currVal_6;
  const currVal_7:any = _decl0_1.yearCellComponent;
  currVal_7;
  const currVal_8:any = _decl0_1.size;
  currVal_8;
  const currVal_9:any = _decl0_1.visibleDate;
  currVal_9;
  const currVal_10:any = _decl0_1.showHeader;
  currVal_10;
  const currVal_11:any = _decl0_1.range;
  currVal_11;
  const currVal_12:any = _decl0_0.medium;
  currVal_12;
  const currVal_13:any = _decl0_0.large;
  currVal_13;
  const pd_14:any = ((<any>_decl0_1.onChange(_any)) !== false);
}
function _View_NbCalendarRangeDayCellComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_2.inRange;
  currVal_0;
  const currVal_1:any = _decl0_2.start;
  currVal_1;
  const currVal_2:any = _decl0_2.end;
  currVal_2;
  const pd_3:any = ((<any>_decl0_2.onClick()) !== false);
}
function _View_NbCalendarRangeDayCellComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_2.today;
  currVal_0;
  const currVal_1:any = _decl0_2.selected;
  currVal_1;
  const currVal_2:any = _decl0_2.boundingMonth;
  currVal_2;
  const currVal_3:any = _decl0_2.start;
  currVal_3;
  const currVal_4:any = _decl0_2.end;
  currVal_4;
  const currVal_5:any = _decl0_2.inRange;
  currVal_5;
  const currVal_6:any = _decl0_2.disabled;
  currVal_6;
  const currVal_7:any = _decl0_2.day;
  currVal_7;
}
function _View_NbCalendarRangeYearCellComponent_Host_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_3.selected;
  currVal_0;
  const currVal_1:any = _decl0_3.today;
  currVal_1;
  const currVal_2:any = _decl0_3.disabled;
  currVal_2;
  const pd_3:any = ((<any>_decl0_3.onClick()) !== false);
}
function _View_NbCalendarRangeYearCellComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_3.year;
  currVal_0;
}
